import React, {Fragment} from "react";
import PropTypes from "prop-types";
import AlertComponent from "./AlertComponent";


const URL_PATTERN = /(\b(https?|ftp):\/\/[A-Z0-9+&@#\/%?=~_|!:,.;-]*[-A-Z0-9+&@#\/%=~_|])/gim;
class CxAlertComponent extends React.Component {
    constructor(props){
        super(props);
    }

    extractMessage(alert){
        let __html;
        if (alert.alertMessage.match(URL_PATTERN)){
            __html =  alert.alertMessage.replace(URL_PATTERN, " <a href=\"$1\" target=\"_blank\">$1</a> ");
        } else {
            __html = alert.alertMessage;
        }
        return {__html};
    }

    render(){
        const {alerts} = this.props;
        if (! alerts || alerts.length === 0){
            return "";
        }
        return (
            <Fragment>
            {
                alerts.map(alert => (
                    <div
                        className={"alert push-half--bottom alert--" + (alert.level === 'HIGH' ? 'error' : 'warning')}
                    >
                        <div className={"alert__icon"}>
                            <i className={"icon--medium fa " + AlertComponent.chooseAttentionIcon(alert.level === 'HIGH' ? 'error' : 'warning')} aria-hidden="true"></i>
                        </div>
                        <div className={"alert__heading display--block overflow-wrap--break-word"} dangerouslySetInnerHTML={this.extractMessage(alert)}>
                        </div>
                    </div>
                ))
            }
            </Fragment>
        );

    }
}

CxAlertComponent.propTypes = {
    alerts: PropTypes.array
};

export default CxAlertComponent;
